import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_WEATHERS_SUCCESS = 'GET_SCENARIO_WEATHERS_SUCCESS'
export const GET_SCENARIO_WEATHERS_FAILURE = 'GET_SCENARIO_WEATHERS_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_WEATHER_SUCCESS = 'CREATE_SCENARIO_WEATHER_SUCCESS'
export const CREATE_SCENARIO_WEATHER_FAILURE = 'CREATE_SCENARIO_WEATHER_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_WEATHER_SUCCESS = 'UPDATE_SCENARIO_WEATHER_SUCCESS'
export const UPDATE_SCENARIO_WEATHER_FAILURE = 'UPDATE_SCENARIO_WEATHER_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_WEATHER_SUCCESS = 'DELETE_SCENARIO_WEATHER_SUCCESS'
export const DELETE_SCENARIO_WEATHER_FAILURE = 'DELETE_SCENARIO_WEATHER_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_WEATHERS = 'SEARCH_SCENARIO_WEATHERS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a scenario's weather's attributes based on its name.
 *
 * @param {string} terms Text to be searched within the scenario weather.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioWeathers = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_WEATHERS,
    data: terms
  })
}

/**
 * GET the list of all the weathers attributes that belong to a specific scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<array<object>>}
 */
export const getScenarioWeathers = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_WEATHER_DATA_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.getScenarioWeathers()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_WEATHERS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_WEATHERS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new scenario's weather's attribute.
 *
 * @param {object} newWeather New scenario's weather attribute object to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {object}
 */
export const createScenarioWeather = (newWeather, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_WEATHER_DATA_CREATE, { pid, sid })
  const api = new Api(path)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  const result = await api.create(newWeather, config)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.createWeather()', { path, newWeather, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_WEATHER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_WEATHER_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario's weather's attribute.
 *
 * @param {object} newWeather Scenario's weather object that will replace the previous one.
 * @param {uuid} wid Scenario weather ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioWeather = (newWeather, wid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_WEATHER_DATA_UPDATE, { pid, sid, wid })
  const api = new Api(path)
  const result = await api.update(newWeather)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.updateScenarioWeather()', { path, newWeather, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_WEATHER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_WEATHER_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario's weather attribute.
 *
 * @param {uuid} wid Scenario weather ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioWeather = (wid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_WEATHER_DATA_DELETE, { pid, sid, wid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] weathersActions.deleteScenarioWeather()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_WEATHER_SUCCESS,
      data: wid
    })
  }
  return dispatch({
    type: DELETE_SCENARIO_WEATHER_FAILURE,
    data: result.data
  })
}
